import React from 'react';
import moment from 'moment-timezone';
import { useDispatch, useSelector } from 'react-redux';
// import { FormGroup, Label, Input } from 'reactstrap';
import { formatPhoneToNum, formatNumToPhone } from '../../../../utils/format-tel';


function UserDetailsTextInput({
  pattern,
  id,
  capitalize,
  disabled,
  type,
  placeholder,
  label,
}) {
  const dispatch = useDispatch();
  const {
    errors,
    values: details,
    editing,
    saving,
  } = useSelector(store => store.details);

  function isValid(value) {
    // Assume valid if we don't have a validation rule for this field.
    return pattern ? value.match(pattern) !== null : true;
  }

  function handleChange({ target }) {
    let { value } = target;

    if (id === 'mobile_phone') {
      if (value === '' || value === null) {
        value = '';
      } else {
        if (value.match(/\(\d{0,3}$/)) {
          value = value.substring(0, value.length - 1);
        }
        value = formatPhoneToNum(value);
      }
    }

    dispatch({ type: 'EDIT_DETAILS', id, value, valid: isValid(value) });
  }

  let value = details[id];
  if (id === 'mobile_phone') {
    value = formatNumToPhone(details[id]);
  } else if (id === 'last_updated') {
    value = moment.tz(details[id], moment.tz.guess()).format('MM/DD/YYYY HH:mm z');
  }

  return (
    <div className="font-large mb-2">
      <label htmlFor={id} className="form-label fw-bold">
        {label}
      </label>
      <input
        id={id}
        className={`form-control ${capitalize ? 'text-capitalize' : ''} ${errors[id] && 'invalid'}`}
        onChange={(e) => handleChange(e)}
        value={value || ''}
        placeholder={placeholder || ''}
        disabled={disabled || !editing || saving}
        type={type}
      />
    </div>
  );
}

export default UserDetailsTextInput;
